<template lang="pug">
    .container-fluid.flex.column.center.gap-2
        vm-row.flex.start.gap-0.margin-left(vm-w="12")
            vm-col(vm-w="1.5")
                .bold {{$t('strings.search_by_date') + ":"}}
            vm-col(vm-w="3")
                date-picker-dashboard(:currentDate="true" @action="filterByMonth")
        vm-row(vm-align="center")
            vm-col(vm-w="4")
                card-resize-dashboard(id="card_dashboard_1" :amount="dashboard.incomes" :title="$t('strings.income')" color="green-color")
            vm-col.flex.center(vm-w="4")
                card-resize-dashboard(id="card_dashboard_2" :amount="dashboard.expenses" :title="$t('strings.expenses')" color="red-color")
            vm-col.flex.end(vm-w="4")
                card-resize-dashboard(id="card_dashboard_3" :amount="dashboard.difference" :title="$t('strings.difference')" color="gray-color")
        vm-row()
            vm-col(vm-w="6")
                card-resize-dashboard(id="card_dashboard_4" :amount="dashboard.quoted" :title="$t('strings.quoted')" color="orange-color" :maxWidth="true")
            vm-col.flex.end(vm-w="6")
                card-resize-dashboard(id="card_dashboard_5" :amount="dashboard.authorized" :title="$t('strings.authorized_quotes')" color="light-green-color" :maxWidth="true")
        vm-row(vm-w="12")
            .card_dashboard.apexchart_container.flex.gap-1.column
                vm-row(vm-w="12")
                    .bold.margin-left {{$t('strings.quoted_vs_authorized')}}
                area-chart-dashboard(:series="dashboard.areaChartData" :key="refresh")
        vm-row.margin-bottom()
            vm-col(vm-w="6")
                .bold.margin-bottom.margin-left {{$t('strings.open_quotes')}}
                table-dashboard(:data="dashboard.openQuotizations.data" :totalPages="dashboard.openQuotizations.totalPages" translations="quotations" :columns="quotationColumns" @loadRecords="loadRecordsQuoted" @search="onSearchQuoted" @clickDelete="onSearchQuoted('')")
            vm-col(vm-w="6")
                .bold.margin-bottom.margin-left {{$t('strings.authorized_quotes')}}
                .flex.end
                    table-dashboard(:data="dashboard.authorizedQuotizations.data" :totalPages="dashboard.authorizedQuotizations.totalPages" translations="quotations" :columns="quotationColumns" @loadRecords="loadRecordsAuthorized" @search="onSearchAuthorized" @clickDelete="onSearchAuthorized('')")
</template>

<script>
// import ViewMixinMaster1 from '@/mixins/ViewMixinMaster1'
import { createNamespacedHelpers } from 'vuex'
import parserFilters from '@/utils/parserFilters'

import moment from 'moment'
const { mapGetters, mapActions } = createNamespacedHelpers('Dashboard')

const MoneyCard = () => import('@/components/aditionals/MoneyCard.vue')
const CardResizeDashboard = () => import('@/components/dashboard/CardResizeDashboard.vue')
const InputDashboard = () => import('@/components/dashboard/InputDashboard.vue')
const DatePickerDashboard = () => import('@/components/dashboard/DatePickerDashboard.vue')
const TableDashboard = () => import('@/components/dashboard/TableDashboard.vue')
const AreaChartDashboard = () => import('@/components/dashboard/AreaChartDashboard.vue')

export default {
  name: 'QuotizationsDashboard',
  components: {
    InputDashboard,
    DatePickerDashboard,
    MoneyCard,
    TableDashboard,
    AreaChartDashboard,
    CardResizeDashboard
  },
  data () {
    return {
      quotationColumns:
        [
          'folio',
          'customer',
          'currency',
          'status'
        ],
      filtersOpenQuotations: {
        where: {
          status: 1,
          created_at: moment().format('YYYY-MM'),
          folio: '',
          param: ''
        }
      },
      filtersAuthorizedQuotations: {
        where: {
          status: 2,
          created_at: moment().format('YYYY-MM'),
          folio: '',
          param: ''
        }
      },
      refresh: 0,
      date: ''
    }
  },
  computed: {
    ...mapGetters([
      'dashboard'
    ])
  },
  created () {
    this.loadGeneralDashboardData({ date: '' })
    this.loadDashboardAreaChart({ date: '' })
    this.loadDashboardTablesData({ page: 1, filters: parserFilters(this.filtersOpenQuotations), status: 1 })
    this.loadDashboardTablesData({ page: 1, filters: parserFilters(this.filtersAuthorizedQuotations), status: 2 })
  },
  methods: {
    ...mapActions([
      'loadGeneralDashboardData',
      'loadDashboardAreaChart',
      'loadDashboardTablesData'
    ]),
    async filterByMonth (date) {
      this.date = (date.length === 7) ? date : ''
      await this.loadGeneralDashboardData({ date: this.date })
      await this.loadDashboardAreaChart({ date: this.date })
      this.filtersAuthorizedQuotations.where.created_at = this.date
      this.filtersOpenQuotations.where.created_at = this.date
      this.loadDashboardTablesData({ page: 1, filters: parserFilters(this.filtersOpenQuotations), status: 1 })
      this.loadDashboardTablesData({ page: 1, filters: parserFilters(this.filtersAuthorizedQuotations), status: 2 })
    },
    loadRecordsQuoted (page) {
      this.loadDashboardTablesData({ page: page, filters: parserFilters(this.filtersOpenQuotations), status: 1 })
    },
    onSearchQuoted (input) {
      this.filtersOpenQuotations.where.folio = input
      this.loadDashboardTablesData({ page: 1, filters: parserFilters(this.filtersOpenQuotations), status: 1 })
    },
    loadRecordsAuthorized (page) {
      this.loadDashboardTablesData({ page: page, filters: parserFilters(this.filtersAuthorizedQuotations), status: 2 })
    },
    onSearchAuthorized (input) {
      this.filtersAuthorizedQuotations.where.folio = input
      this.loadDashboardTablesData({ page: 1, filters: parserFilters(this.filtersAuthorizedQuotations), status: 2 })
    }
  }
}
</script>
